exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".leadTabs-53f92{width:100%}.leadTabs-53f92 .ant-tabs-nav{margin:0;padding:12px 24px}.leadTabs-53f92 .ant-tabs-nav:before{border-bottom-color:#d9d9d9 !important}.leadTabs-53f92 .ant-tabs-ink-bar{display:none}", ""]);

// Exports
exports.locals = {
	"leadTabs": "leadTabs-53f92"
};